import { useState } from "react";
import { changeRiskLevelRequest } from "../network";

const normalizeRiskLevel = (value?: string) => (value || "").trim().toUpperCase();

export const useChangeRiskOrStatusWithRisk = (
  verificationId: string,
  riskLevel: string,
  riskLevelReason: string,
  value?: string,
  changeStatusRequest?: (
    action: string,
    additional?: {
      reason?: string;
      message?: string;
    }
  ) => Promise<void> | void,
  currentRisk?: {
    riskLevel?: string;
    riskLevelReason?: string;
  } | null
): [() => Promise<void>, boolean, Error | null, any | null] => {
  const [result, setResult] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const shouldSkipRiskLevelUpdate =
        currentRisk != null &&
        normalizeRiskLevel(currentRisk.riskLevel) ===
          normalizeRiskLevel(riskLevel) &&
        (currentRisk?.riskLevelReason || "") === riskLevelReason;

      if (shouldSkipRiskLevelUpdate) {
        if (changeStatusRequest && value) {
          await changeStatusRequest(value);
        } else {
          setResult({ skipped: true });
        }
        return;
      }

      const response = await changeRiskLevelRequest(
        verificationId,
        riskLevel,
        riskLevelReason
      );
      setResult(response);

      if (changeStatusRequest && value) {
        await changeStatusRequest(value);
      }
    } catch (e) {
      if (e instanceof Error) {
        setError(e);
      } else {
        setError(new Error("Unknown error"));
      }
    } finally {
      setIsLoading(false);
    }
  };

  return [request, isLoading, error, result];
};
